import React, { useCallback } from 'react'
import { Modal } from 'semantic-ui-react'
import { setProducts, getAProduct } from '../../redux/actions/products'
import { ConfirmationModal } from './ConfirmationModal'

interface Props {
  unsavedWarning: boolean
  setUnsavedWarning: (status: boolean) => void
  dispatch: any
  values: any
}

export const UnsavedWarningModal = (props: Props) => {
  const { unsavedWarning, setUnsavedWarning, dispatch, values } = props

  const onConfirm = useCallback(() => {
    dispatch(setProducts({ products: [] }))
    dispatch(getAProduct({ productId: values.id, mode: 'edit' }))
  }, [dispatch, values])

  return (
    <ConfirmationModal open={unsavedWarning} setOpen={setUnsavedWarning} onConfirm={onConfirm}>
      <Modal.Header>Proceed without saving?</Modal.Header>
      <Modal.Content>
        <p>All unsaved changes will be lost</p>
      </Modal.Content>
    </ConfirmationModal>
  )
}
